// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#InstanceProfile-module-banner {
  width: 100%;
  background-color: gray;
  border-radius: 5px;
  aspect-ratio: 4;
}
`, "",{"version":3,"sources":["webpack://./src/Router/App/components/InstanceProfile/InstanceProfile.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["#banner {\r\n  width: 100%;\r\n  background-color: gray;\r\n  border-radius: 5px;\r\n  aspect-ratio: 4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var banner = `InstanceProfile-module-banner`;
export default ___CSS_LOADER_EXPORT___;
